<template>
    <div id="product-configurator" :class="product != null && product.Product != null && product.Product.ProductType == 2 && partnumbersByColor != undefined && partnumbersByColor.length == 1 ? 'one-size' : ''" v-if="product && product.ShowProductSelector == true">
        <V12 :V12Label="product.V12Label" :V12FinanceProducts="product.V12FinanceProducts" :Product="product" :Amount="partnumber != null ? partnumber.price : product.Partnumbers[0].price" v-if="product.V12FinanceProducts != undefined && product.V12FinanceProducts.length > 0"></V12>

        <!--Addons Description when available-->
        <p id="bundlesIntro" v-if="bundles && bundles.length > 0 && getInterfaceText('shop_bundles_intro').length > 0" v-html="getInterfaceText('shop_bundles_intro')"></p>

        <div class="wrapper">
            <!-- 2 or more colors: circles-->
            <!--<template v-if="product.ColorCodes && product.ColorCodes.length > 1 && hasUsage == false">-->
            <template v-if="product.ColorCodes && product.ColorCodes.length > 1 && (hasUsage == false || hasDifferentSizes == true)">
                <!--WDR 20230309: Indien Partnumber.Usage waardes heeft dan Colour waardes negeren. -->
                <p class="subheading">
                    <span class="headinglabel">{{getInterfaceText('shop_color')}}</span>
                    <span class="headingvalue" v-show="color.length > 0"> - <strong>{{color}}</strong></span>
                    <span class="headinglabel" v-if="partnumber != null && product.PriceDifferences"> ({{partnumber.priceToFormat}})</span>
                </p>
                <div class="colors">
                    <template v-for="item in product.ColorCodes" :key="item.Description">
                        <input type="radio" name="color" :value="item.Description" :id="'radio' + item.Description" v-model="color" v-on:click="selectColor(item)" />
                        <label :for="'radio' + item.Description" :class="color == item.Description ? 'selected' : ''" :title="item.Description">
                            <i class="icongiant-check"></i>
                            <span class="circle-border">
                                <span class="circle" :style="{ backgroundColor: '#'+item.HexCodePrimary }"></span>
                                <span :v-if="item.HexCodePrimary" class="halfcircle" :style="{ backgroundColor: '#'+item.HexCodeSecondary }"></span>
                            </span>
                            <!--<span class="text">{{item.Description}}</span>-->
                        </label>
                    </template>
                </div>
            </template>
            <template v-else-if="hasUsage == true && (product.Partnumbers.length > 1 || partnumbersByColor[0].size.length > 0)">
                <p class="subheading">
                    <span class="headinglabel">{{getInterfaceText('shop_selectyourversion')}}</span>
                    <span class="headingvalue" v-if="partnumber != null"> - <strong>{{partnumber.description}}</strong></span>
                </p>
            </template>

            <!--e-commerce block-->
            <div>
                <!-- size blocks with extra info and dealers -->
                <div :class="(product.StoreSaleProduct == null ? 'sizes' : '')" v-show="product.Product != null && product.Partnumbers != null && product.Partnumbers.length > 0 && partnumbersByColor.length > 0 && (product.Partnumbers.length > 1 || partnumbersByColor[0].size.length > 0) && (hasSizes == true || hasUsage == true)">
                    <p class="subheading" v-show="hasUsage == false && viewmode != 'axapta'">
                        <span v-if="product.StoreSaleProduct == null">
                            <span class="headinglabel" v-if="partnumber != null && partnumber.code.length > 0">{{getInterfaceText('shop_size')}}</span>
                            <span class="headinglabel" v-else>{{getInterfaceText('shop_size_choose')}}</span>
                            <span class="headingvalue" v-if="partnumber != null && partnumber.code.length > 0"> - <strong>{{partnumber.description}}</strong></span>
                        </span>
                        <span v-else>
                            <span class="headinglabel">&nbsp;</span>
                        </span>
                        <!-- whatismysize - different versions -->
                        <span class="whatismysize-wrapper" v-show="(product.Product.SizingSheetUrl != undefined && product.Product.SizingSheetUrl.length > 0) || product.Product.GearSizingPageId || product.Product.HasFrameSizes || product.SmartfitAvailable || product.EyeFitUAvailable">
                            <span class="whatismysize" v-if="showBikeAdvancedSizingTool">
                                <a href="#" v-on:click="trackEventBikeAdvancedSizingTool" data-toggle="modal" data-target="#advancedSizingToolModal">{{getInterfaceText('shop_whatismysize')}}</a>
                            </span>
                            <span class="whatismysize" v-else-if="product.SmartfitAvailable">
                                <!-- Smart Fit V2 -->
                                <a href="javascript:void(0);"
                                   id="custom-oz-button"
                                   class="oz-trigger"
                                   :data-oz-code="product.Partnumbers[0].barcode"
                                   :data-oz-name="product.Product.Name"
                                   :data-oz-image="(product.Product.CloudinaryImagesToPartnumbers.length > 0 ? product.Product.CloudinaryImagesToPartnumbers[0].CloudinaryImage.ImageUrlMain : '')"
                                   data-oz-fullscreen="true"
                                   onclick="trackEventGlobalAndLocal('Size', 'Standard', 'SmartFit');"
                                   data-oz-embed="custom"
                                   oz-trigger-id="custom-oz-button">{{getInterfaceText('shop_whatismysize')}}</a>
                            </span>
                            <span class="whatismysize" v-else-if="product.EyeFitUAvailable">
                                <!-- EyeFitU -->
                                <article style="height: 44px"
                                         data-eyefitu-sizing-widget="true"
                                         :data-language="language"
                                         :data-brand="product.EyeFitU.Brand"
                                         :data-product="product.EyeFitU.Title"
                                         :data-image="product.Product.Image"
                                         :data-gender="product.EyeFitU.Gender"
                                         :data-sizes="JSON.stringify(product.Partnumbers.map(a => a.size))"
                                         :data-default-units="measurement == 'Miles' ? 'imperial' : 'metric'"
                                         :data-giant-fit="product.EyeFitU.Fit"
                                         data-flow="giant"
                                         class="notranslate">
                                </article>
                            </span>
                            <span class="whatismysize" v-else-if="product.Product != null && product.Product.SizingSheetUrl != undefined && product.Product.SizingSheetUrl.length > 0">
                                <a data-fancybox :href="product.Product.SizingSheetUrl" onclick="trackEventGlobalAndLocal('Size', 'Standard', 'Sizing sheet');">{{getInterfaceText('shop_whatismysize')}}</a>
                            </span>
                            <span class="whatismysize" v-else-if="product.Product != null && product.Product.GearSizingPageId != undefined && product.Product.GearSizingPageId > 0">
                                <a data-fancybox data-type="iframe" :href="'/'+ countryCode +'/gear/sizingpage/'+ product.Product.GearSizingPageId" onclick="trackEventGlobalAndLocal('Size', 'Standard', 'Sizing Page');" style="color: #676767;"><i class="glyphicon glyphicon-question-sign" style="margin-right:5px;"></i>{{getInterfaceText('shop_whatismysize')}}</a>
                            </span>
                            <span class="whatismysize" v-else-if="product.Product != null && product.Product.HasFrameSizes">
                                <a href="#geometry" id="bikeframesize-geometry-tab" class="act-like-tab-click" onclick="trackEventGlobalAndLocal('Size', 'Standard', 'Frame sizes');" style="color: #676767;"><i class="glyphicon glyphicon-question-sign" style="margin-right:5px;"></i>{{getInterfaceText('shop_whatismysize')}}</a>
                            </span>
                            <span class="whatismysize" v-else>
                                <!--nothing-->
                            </span>
                        </span>
                    </p>

                    <!-- SIZES -->
                    <div class="row-fluid clearfix" v-if="product.StoreSaleProduct == null">
                        <template v-for="item in partnumbersByColor" :key="item.code">
                            <!-- SIZE -->
                            <button class="name-and-stockinfo size" :class="item == partnumber ? 'size-selected' : ''" :id="item.code" v-on:click="togglePartnumber(item)">
                                <div class="name">{{item.description}}</div>
                                <span v-if="product.PriceDifferences">&nbsp;({{item.priceToFormat}})</span>
                            </button>
                        </template>
                    </div>
                </div>

                <p class="sizingnote" v-show="product.Product.SizingNote != null">
                    {{product.Product.SizingNote}}
                </p>

                <div id="selected-partnumber" :class="{ invisible: !(partnumber != null && partnumber.code.length > 0) }" v-if="product.StoreSaleProduct == null" style="margin-bottom: 20px;">
                    {{getInterfaceText('shop_product_item#')}}
                    <span v-if="partnumber != null && partnumber.code.length > 0">{{ partnumber.code }}</span>
                    <span v-if="partnumber != null && partnumber.stock != null && isRetailDirectToConsumer" :class="partnumber.stock.CssClass" class="stockinfo"> | {{partnumber.stock.Label}}</span>
                    <span v-if="partnumber != null && partnumber.stock != null && isRetailDirectToConsumer && isStore == false && partnumber.stock.ContainsLocalstock">
                        | <a href="javascript:void(0)" class="show-dealer-selector" v-on:click="setShowDealerSelector = !setShowDealerSelector;">
                            <span v-show="setShowDealerSelector == false">{{getInterfaceText('shop_rd2c_showretailersthathaveinstore')}}</span>
                            <span v-show="setShowDealerSelector == true">{{getInterfaceText('shop_rd2c_hideretailersthathaveinstore')}}</span>
                        </a>
                    </span>
                </div>

                <template v-if="partnumber != null && partnumber.code.length > 0 && partnumber.supplementaryGroup != null">
                    <label class="sr-only" for="supplementaryItems" id="supplementaryLabelSr">{{getInterfaceText('supplementaryitems')}}</label>
                    <label class="hidden" id="supplementaryValueSr">{{supplementaryItem.length > 0 ? supplementaryItem.description : partnumber.supplementaryGroup.label}}</label>
                    <p class="subheading">
                        <span class="headinglabel">{{partnumber.supplementaryGroup.label}}</span>
                        <span class="headingvalue" v-show="supplementaryItem != null && supplementaryItem.code != null"> - <strong>{{supplementaryItem.description}}</strong></span>
                    </p>
                    <div class="supplementaryItems sizes clearfix">
                        <p for="supplementaryItems" style="font-size:13px;">{{partnumber.supplementaryGroup.introText}}<span v-show="partnumber.supplementaryGroup.url != null">&nbsp;<a class="fancybox fancybox.iframe" data-fancybox data-type="iframe" data-src="{{partnumber.supplementaryGroup.url != null ? partnumber.supplementaryGroup.url + '?frame=popup' : ''}}">{{partnumber.supplementaryGroup.urlLabel}} <i class="glyphicon glyphicon-new-window" aria-hidden="true"></i></a></span></p>
                        <template v-for="item in partnumber.supplementaryGroup.items" :key="item.code">
                            <button class="name-and-stockinfo size" :class="(item == supplementaryItem ? 'size-selected ' : '') + (supplementaryItem != null && supplementaryItem.stock != null && supplementaryItem.stock.Code == 0 && item != supplementaryItem ? ' disabled' : '')" :id="supplementaryItem.code" v-on:click="selectSupplementaryItem(item)" :disabled="supplementaryItem != null && supplementaryItem.stock != null && supplementaryItem.stock.Code == 0 && item != supplementaryItem">
                                <div class="name">{{item.description}} + {{item.priceToFormat}}</div>
                            </button>
                        </template>
                    </div>
                </template>

                <!--e-commerce-->
                <div v-if="product.ShopActive && viewmode != 'axapta'">
                    <!--stock info-->
                    <div class="stockcontainer" v-if="product.StoreSaleProduct != null || (partnumber != null)" v-show="(isRetailDirectToConsumer == false || setShowDealerSelector)">
                        <div class="heading-and-link" v-if="isRetailDirectToConsumer == false && isStore == false">
                            <div class="heading">
                                {{getInterfaceText('shop_howtogetit')}}
                                <span v-show="partnumber != null && partnumber.stock != null && partnumber.stock.Code == 1 && displayInstockLabelAsInfoIconPopout == true" class="filter-tooltip" data-toggle="tooltip" data-placement="top" :data-original-title="stockDescription"><span class="glyphicon glyphicon-info-sign"></span></span>
                            </div>
                            <div class="link">
                                <a v-if="countryId == 1" href="#" v-on:click="trackPickItUpInStore" data-toggle="modal" data-target="#modalWhyPickupInStore">Why pick up in store?</a>
                                <a v-else-if="product.WhyPickItUpInStorePageUrl != null && product.WhyPickItUpInStorePageUrl.length > 0" v-on:click="trackPickItUpInStore" data-fancybox data-type="iframe" href="javascript:void(0);" :data-src="product.WhyPickItUpInStorePageUrl" class="pull-right">{{getInterfaceText('page_whypickupinstore_link_label')}}</a>
                            </div>
                        </div>

                        <div class="storesaleproduct" v-if="product.StoreSaleProduct != null">
                            <p class="availablesizes" v-if="product.StoreSaleProduct.AvailableSizes != null">
                                <strong>{{getInterfaceText('store_availablesizes')}}</strong>: {{product.StoreSaleProduct.AvailableSizes}}<br />
                                <span class="instoreonly">{{getInterfaceText('instoresalelabel')}}</span>
                            </p>
                        </div>

                        <!-- WhyPickupInStore modal -->
                        <div id="modalWhyPickupInStore" v-if="countryId == 1" class="modal fade" role="dialog" aria-modal="true" aria-label="Why pick up in store?">
                            <div class="modal-dialog modal-lg">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
                                        <h1 class="modal-title" style="color:#000;text-transform: none;">Why pick up in store?</h1>
                                    </div>
                                    <div class="modal-body text-left" style="padding: 25px;">

                                        <p style="padding-bottom:20px;">
                                            <img v-if="product.Product.BrandId == 3" src="https://static.giant-bicycles.com/Images/Shared/Shop/image_whypickitupinstore_momentum.jpg" class="img-responsive lazy-loading" alt="" width="848" height="343" />
                                            <img v-else src="https://static.giant-bicycles.com/Images/Shared/Shop/image_whypickupinstore5.jpg" class="img-responsive lazy-loading" alt="" width="848" height="343" />
                                        </p>

                                        <p>
                                            Giant believes the Giant/Liv/Momentum retailer is an essential part of the cycling foundation.
                                            Competent bicycle retailers make the difference in creating a cyclist for life.
                                            Our family of retailers is ready to communicate our mutual commitment to the cycling
                                            lifestyle and its lifelong health benefits. Our promise to you; we are committed to your riding experience,
                                            <strong>
                                                there is no better way to service, fit, or impact the cycling experience with such emotion and sustainability
                                                than through an energized Giant/Liv/Momentum retailer.
                                            </strong>
                                        </p>
                                        <p>
                                            Thank you for supporting a local business. Let's ride!
                                        </p>
                                        <p>
                                            All the best,<br />
                                            John 'JT' Thompson<br />
                                            General Manager - Giant Bicycle USA
                                        </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="partnumber != null">
                            <div class="stock-info-wrapper" v-if="isRetailDirectToConsumer == false">
                                <p class="stockinfo" :class="partnumber.stock.CssClass">{{partnumber.stock.Label}}<br /></p>
                                <p class="stockdescription" v-if="partnumber.stock.Code != 1 && partnumber.stock.Code != 2 && partnumber.stock.Description != null">{{partnumber.stock.Description}}</p>
                                <p v-if="partnumber.stock.Code == 3">
                                    {{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickup-preorder1')}}&nbsp;<strong>{{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickup-preorder2')}}&nbsp;{{partnumber.stock.DateExpectedToFormat}}</strong>&nbsp;{{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickup-preorder3')}}
                                    {{label_shop_at_any_retailer}}
                                    {{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickup-preorder4')}}
                                    <strong>{{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickupabout-preorder5')}} <span v-if="partnumber.stock.DateExpectedToWeeks <= 1">1 {{getInterfaceText('shop_week')}}</span><span v-show="partnumber.stock.DateExpectedToWeeks > 1">{{partnumber.stock.DateExpectedToWeeks}}-{{partnumber.stock.DateExpectedToWeeks + 1}} {{getInterfaceText('shop_weeks')}}</span></strong>
                                </p>
                                <p class="stockdescription" v-else-if="partnumber.stock.Code == 0 && partnumber.notifyMe == false">
                                    {{getInterfaceText('shop_productoutofstockcontactlocalstore')}}
                                </p>
                                <p class="stockdescription" v-else-if="partnumber.stock.Code == 2 && isStore == false">
                                    <span v-html="label_shop_inStoreNowAndAvailableForPickup.replace('{{ dealerSearchCity }}',dealerSearchCity)"></span>
                                </p>
                                <p class="stockdescription" v-else-if="partnumber.stock.Code == 1 && isStore">
                                    <span v-html="getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickup')" /> <span v-html="getInterfaceText('shop_inabout7businessdays.')" />
                                </p>
                                <div class="notify-me-wrapper" v-else-if="partnumber.stock.Code == 0 && partnumber.notifyMe == true && isStore == false">
                                    <strong>{{getInterfaceText('shop_notifywhenavailable')}}</strong>
                                    <NotifyMe :partnumberCode="partnumber.code"></NotifyMe>
                                </div>
                                <p class="stockdescription" v-if="displayInstockLabelAsInfoIconPopout == false && partnumber.stock != null && partnumber.stock.Code == 1">{{stockDescription}}</p>
                            </div>

                            <div class="dealers-wrapper" v-if="isStore == false && partnumber.stock.ContainsLocalstock">
                                <a href="javascript:void(0)" class="show-dealer-selector" v-show="partnumber != null && partnumber.stock.Code != 2 && isRetailDirectToConsumer == false" v-on:click="setShowDealerSelector = !setShowDealerSelector;">
                                    <span v-show="setShowDealerSelector == false">{{getInterfaceText('shop_rd2c_showretailersthathaveinstore')}}</span>
                                    <span v-show="setShowDealerSelector == true">{{getInterfaceText('shop_rd2c_hideretailersthathaveinstore')}}</span>
                                </a>
                                <div v-if="setShowDealerSelector">
                                    <template v-if="isSelectedDealerInfoVisible(item)">
                                        <!--YES a dealer has been selected-->
                                        <div class="selected-dealer-wrapper">
                                            <DealerSelect :dealer="selectedDealer"
                                                          :selectedDealer="selectedDealer"
                                                          :isInStoreNowTextVisible="isInStoreNowTextVisible"
                                                          :isAvailableInTextVisible="isAvailableInTextVisible"
                                                          :sellLocalStock="sellLocalStock"
                                                          v-on:select-dealer-and-add-to-cart="selectDealerAndAddToCart"
                                                          v-on:remove-selected-dealer="removeSelectedDealer"></DealerSelect>
                                        </div>

                                    </template>
                                    <template v-else>
                                        <!-- title -->
                                        <p v-show="isDealerSearchFieldEnabled" class="select-a-dealer">
                                            <strong>
                                                <span v-show="isRetailDirectToConsumer == false">{{getInterfaceText('shop_findwherebikeisinstore')}}</span>
                                                <span v-show="isRetailDirectToConsumer == true">{{getInterfaceText('shop_rd2c_findwherebikeisinstore', product.Product.Name + ' (' + partnumber.description + ', ' + partnumber.color + ')')}}</span>
                                            </strong>
                                        </p>

                                        <!-- dealer search  -->
                                        <div class="form-group" rel="tooltip" data-placement="left" v-show="isDealerSearchFieldEnabled">
                                            <div class="wrapper-floating-label-and-buttongroup clearfix">
                                                <div class="wrapper-floating-label" :class="{ 'movelabel' : dealerSearchCity != null && dealerSearchCity != '' }" style="width:100%;">
                                                    <label for="inputFindLocalStock">{{getInterfaceText('shop_searchonzipcodeorcity')}}</label>
                                                    <input type="text" v-model="dealerSearchCity" ref="zipcodeCityInput" v-on:keyup.enter="getDealersByLocation()" id="inputFindLocalStock" style="border-top-left-radius: 4px; border-bottom-left-radius: 4px;max-width:inherit;" />
                                                </div>
                                                <div class="input-group input-group-floating-label-style">
                                                    <span class="input-group-btn">
                                                        <button type="button" class="btn btn-storefinder" id="btnFindLocalStock" v-on:click="getDealersByLocation()" style="border-top-right-radius: 4px !important; border-bottom-right-radius: 4px !important; margin-left:-45px;"><i class="glyphicon glyphicon-map-marker" aria-hidden="true"></i></button>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="alert alert-danger" v-show="exceptionMessageDealers.length > 0">{{exceptionMessageDealers}}</div>
                                        </div>

                                        <!-- local stock only checkbox -->
                                        <label for="filterOnlyLocalStock" class="filter-on-local-stock" v-if="isLocalStockFilterCheckboxVisible() && partnumber.stock.IsRetailDirectToConsumer == false && producttypeid == 1" style="margin-bottom:10px;">
                                            <input type="checkbox" v-model="isLocalStockOnlyMode" v-on:change="toggleLocalStockOnlyMode()" id="filterOnlyLocalStock" />
                                            {{getInterfaceText('shop_onlyshowdealershaveinstore')}}
                                        </label>

                                        <!-- dealers to select -->
                                        <div class="dealers" v-if="isDealerListVisible">
                                            <div v-if="loadingDealers" class="loading">{{getInterfaceText('loading')}}</div>
                                            <div v-if="isDealerListVisible && !loadingDealers">
                                                <template v-for="dealer in activeDealers" :key="dealer.Code">
                                                    <DealerSelect :dealer="dealer"
                                                                  :selectedDealer="selectedDealer"
                                                                  :isInStoreNowTextVisible="dealer.Type == 'local'"
                                                                  :isAvailableInTextVisible="isAvailableInTextVisible"
                                                                  :sellLocalStock="sellLocalStock"
                                                                  :partnumber="partnumber"
                                                                  :product="product"
                                                                  v-on:select-dealer-and-add-to-cart="selectDealerAndAddToCart"
                                                                  v-on:remove-selected-dealer="removeSelectedDealer"></DealerSelect>
                                                </template>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>

                            <div v-if="partnumber.stock.Code == 2 && partnumber.notifyMe == true && isStore == false" class="notifyme-wrapper">
                                <a href="javascript:void(0);" v-on:click="showNotifyMe = showNotifyMe ? false : true">{{getInterfaceText('shop_notifywhenavailableatwarehouse')}}</a>
                                <NotifyMe v-show="showNotifyMe" :partnumberCode="partnumber.code" style="margin-top:20px;"></NotifyMe>
                            </div>

                        </div>
                    </div>

                    <!-- add to cart button -->
                    <p v-show="showLabelRequiredPartnumber == true" class="alert alert-danger">
                        {{getInterfaceText('shop_please_select_a_size')}}
                    </p>

                    <p class="add-to-cart">
                        <button class="btn btn-addtocart" v-if="isAddToCartButtonVisible()" v-on:click="addToCart()">{{getInterfaceText('add_to_cart')}}</button>
                        <button class="btn btn-contactus" v-if="isContactButtonVisible() && product.StoreSaleProduct == null" v-on:click="sendToContact()"><span class="text">{{getInterfaceText('shop_contactdealer_store')}}</span></button>
                        <button class="btn btn-contactus" href="#" data-toggle="modal" data-target="#contactModal2" v-on:click="formHasBeenSent = false" v-if="isContactButtonVisible() && product.StoreSaleProduct != null"><span class="text">{{getInterfaceText('shop_contactdealer_store')}}</span></button>
                    </p>
                </div>
            </div>
        </div>

        <div class="alert alert-danger" v-show="exceptionMessageCart != undefined && exceptionMessageCart.length > 0">{{exceptionMessageCart}}</div>

        <div class="addons" v-if="addOns && addOns.length > 0 && viewmode != 'axapta'">
            <p style="margin:0;"><span style="text-transform: uppercase;font-size:14px;">{{getInterfaceText('shop_choose_add_ons')}}</span></p>
            <template v-for="addon in addOns" :key="addon.Id">

                <div class="item" v-on:mouseover="showAddOnOverlayImage(addon)" v-on:mouseout="hideAddOnOverlayImage(addon)" :class="{ 'item-selected' : hasProductInCart(addon.GearGlobalProductId) }">
                    <div class="text">
                        <h5>
                            {{ addon.Name }}
                            <button class="btn btn-info" v-if="addon.Description" type="button" data-toggle="collapse" :data-target="'#collapseItem'+ addon.Id" aria-expanded="false" aria-controls="'collapseItem'+ addon.Id">i</button>
                        </h5>
                        <div class="collapse extra-info" :id="'collapseItem'+ addon.Id">
                            <div class="padding">
                                {{ addon.Description }}
                            </div>
                        </div>
                        <p style="margin-bottom:0;">
                            {{ addon.PriceToFormat }}
                        </p>
                        <button class="btn btn-add" v-show="hasProductInCart(addon.GearGlobalProductId) == false" v-on:click="addCartItem(addon.PartnumberCode, addon.GearLocalProductId, 2, addon, addon.Partnumber);animateAddOn($event)">{{getInterfaceText('add_to_cart')}}</button>
                        <div class="added" v-show="hasProductInCart(addon.GearGlobalProductId)">
                            <span class="added-text"><i class="icongiant-check" aria-hidden="true"></i> {{getInterfaceText('shop_added_to_cart')}}</span>
                            <button class="btn btn-remove" v-on:click="removePartnumberFromCart(addon.PartnumberCode)" title="Remove from cart"><i class="glyphicon glyphicon-trash"></i></button>
                        </div>
                    </div>
                    <div class="image">
                        <a v-if="addon.CloudinaryImageGearProduct" :href="addon.CloudinaryImageGearProduct.ImageUrlZoom" class="galleryzoom" data-fancybox="gallery"><img :src="addon.CloudinaryImageGearProduct.ImageUrlSmall" /></a>
                    </div>
                </div>
            </template>

        </div>
        <div class="bundles" v-if="bundles && bundles.length > 0 && viewmode != 'axapta'">
            <p style="margin:0;"><span style="text-transform: uppercase;font-size:14px;">{{getInterfaceText('shop_choose_bundles')}}</span></p>
            <p v-if="getInterfaceText('shop_choose_bundles_disclaimer').length > 0" style="font-size: 12px;">{{getInterfaceText('shop_choose_bundles_disclaimer')}}</p>
            <div style="border-top: 1px solid rgb(233, 233, 233); padding-top: 20px;">
                <template v-for="bundle in bundles" :key="bundle">
                    <BundleItem :bundle="bundle" :parentProduct="this.product"></BundleItem>
                </template>
            </div>
        </div>
        <div class="modal fade" id="contactModal2" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header text-left">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" style="font-weight:bold;" id="myModalLabel">{{getInterfaceText("contact")}}</h4>
                    </div>
                    <div class="modal-body text-left">
                        <p class="errormessage" v-if="errorContact.length > 0">{{errorContact}}</p>
                        <p style="margin-bottom:20px;font-style: italic;">{{getInterfaceText("store_ihaveaquestionaboutthe")}} {{product.Product.Name}}</p>
                        <div class="successMessage" v-show="formHasBeenSent == true"><p style="color: #1a8f09;font-weight:bold;">{{getInterfaceText("form_sent_successfully")}}</p></div>
                        <div class="clearfix" v-show="formHasBeenSent == false">
                            <div class="form-group">
                                <div class="wrapper-floating-label movelabel">
                                    <label>{{getInterfaceText("form_firstname")}} <span class="asterisk">*</span></label>
                                    <input id="FirstName" name="FirstName" type="text" v-model="contactFirstName" required :class="errorContact.length > 0 && (contactFirstName == null || contactFirstName == '') ? 'input-validation-error' : ''" />
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="wrapper-floating-label movelabel">
                                    <label>{{getInterfaceText("form_lastname")}} <span class="asterisk">*</span></label>
                                    <input id="LastName" name="LastName" type="text" v-model="contactLastName" required :class="errorContact.length > 0 && (contactLastName == null || contactLastName == '') ? 'input-validation-error' : ''" />
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="wrapper-floating-label movelabel">
                                    <label>{{getInterfaceText("contact-form_email")}} <span class="asterisk">*</span></label>
                                    <input id="Email" name="Email" type="email" v-model="contactEmail" required :class="errorContact.length > 0 && (contactEmail == null || contactEmail == '') ? 'input-validation-error' : ''" />
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="wrapper-floating-label movelabel">
                                    <label>{{getInterfaceText("contact-form_phone")}}</label>
                                    <input id="Phone" name="Phone" type="text" v-model="contactPhone" />
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="wrapper-floating-label movelabel">
                                    <label>{{getInterfaceText("contact-form_size")}}</label>
                                    <input id="Size" name="Size" type="text" v-model="contactSize" />
                                </div>
                            </div>
                            <div class="form-group" style="margin-bottom: 15px;">
                                <label style="font-weight:normal;">{{getInterfaceText("contact-form_question")}} <span class="asterisk">*</span></label>
                                <textarea class="form-control" id="Question" name="Question" v-model="contactQuestion" required :class="errorContact.length > 0 && (contactQuestion == null || contactQuestion == '') ? 'input-validation-error' : ''"></textarea>
                            </div>
                            <p class="text-right">
                                <button class="btn btn-default" data-dismiss="modal" style="margin-right:5px;">{{getInterfaceText("cancel", "Cancel")}}</button>
                                <button class="btn btn-primary" ng-disabled="isSending" v-on:click="sendContactForm()">{{getInterfaceText("send")}}</button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import vueStore from '../../store/store.js';
    import cartMixin from '../../mixins/cart-mixin.js';
    import generalMixin from '../../mixins/general.js';
    import NotifyMe from '@/components/NotifyMe.vue';
    import DealerSelect from '@/components/DealerSelect.vue';
    import BundleItem from '@/components/BundleItem.vue';
    import V12 from '@/components/V12.vue';
    export default {
        mixins: [cartMixin, generalMixin],
        components: {
            NotifyMe,
            DealerSelect,
            BundleItem,
            V12
        },
        data: function () {
            return {
                exceptionMessageCart: '',
                exceptionMessageDealers: '',
                dealerSearchCity: '',
                isDealerListVisible: true,
                isDealerSearchFieldEnabled: false,
                isClientSearchFieldEnabled: false,
                isLocalStockOnlyMode: true,
                isWillingToTakeARoadTrip: false,
                isInStoreNowTextVisible: true,
                isAvailableInTextVisible: true,
                activeDealers: [],
                isNotifyMeVisible: false,
                loadingDealers: true,
                isStore: window.store.length > 0,
                pickupAvailable: false,
                showShippingCostsAtProductSelector: false,
                label_shop_inStoreNowAndAvailableForPickup: window.label_shop_inStoreNowAndAvailableForPickup,
                label_shop_orPickItUpAtStore: window.label_shop_orPickItUpAtStore,
                label_shop_at_any_retailer: window.label_shop_at_any_retailer,
                label_shop_ifYouAreWillingToTakeARoadTrip: window.label_shop_ifYouAreWillingToTakeARoadTrip,
                id: '',
                producttypeid: '',
                culture: window.culture,
                countryId: window.countryId,
                countryCode: window.countryCode,
                partnumberDefault: '',
                setShowDealerSelector: false,
                addingProductToCart: false,
                enterLocationEnabled: false,
                measurement: window.measurement,
                showBikeAdvancedSizingTool: false,
                language: window.languageCode,
                viewmode: '',
                showLabelRequiredPartnumber: false,
                displayInstockLabelAsInfoIconPopout: true,
                sellLocalStockStoreSites: false,
                showNotifyMe: false,
                errorContact: '',
                isSending: false,
                formHasBeenSent: false,
                grecaptcha: window.grecaptcha
            }
        },
        methods: {
            async fetchApi() {
                if (this.id > 0) {
                    await axios.get(this.apiUrl)
                        .then((response) => {
                            vueStore.commit('setProduct', response.data)
                            //set default values
                            if (this.partnumberDefault != null && this.partnumberDefault.length > 0) {
                                var partnumber = response.data.Partnumbers?.filter(x => x.code == this.partnumberDefault)
                                if (partnumber.length > 0) {
                                    vueStore.commit('setPartnumber', partnumber[0]);
                                    this.color = partnumber[0].color;
                                }
                            }
                        })
                }
            },
            removeSelectedDealer() {
                vueStore.commit('setDealer', null);
            },
            selectDealerAndAddToCart(dealer) {
                // SK add ga4 tracking
                window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'select_retailer', 'ga4_model_category': this.product.GA_Category, 'ga4_model_name': this.product.Product.Name, 'ga4_click_text': dealer.Name });
                // set  dealer in vue-store
                vueStore.commit('setDealer', dealer);
                // add to cart
                this.addCartItem(this.partnumber.code, this.id, this.producttypeid, this.product.Product, null, function () { document.getElementById("cart-summary-container2").click(); });
            },
            selectColor(color) {
                // SK add ga4 tracking
                window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'select_color', 'ga4_model_category': this.product.GA_Category, 'ga4_model_name': this.product.Product.Name, 'ga4_click_text': color.Description });
            },
            selectSupplementaryItem(supplementaryItem) {
                if (this.supplementaryItem == supplementaryItem) {
                    supplementaryItem = {};
                } else {
                    // SK add ga4 tracking
                    window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'select_supplementary', 'ga4_model_category': this.product.GA_Category, 'ga4_model_name': this.product.Product.Name, 'ga4_click_text': supplementaryItem.description });
                }
                vueStore.commit('setSupplementaryItem', supplementaryItem);
            },
            togglePartnumber(partnumber) {
                //reset dealer selector
                this.setShowDealerSelector = false;
                //set partnumber to null if partnumber is already selected (toggle)
                if (this.partnumber != null && this.partnumber.code == partnumber.code) {
                    partnumber = null;
                    this.resetDefaultPartnumber();
                    // commit action to store
                    vueStore.commit('setPartnumber', partnumber);
                    //set default shipping option
                    //this.shippingOption = this.getFirstShippingOptionAvailable();
                } else {
                    this.setPartnumberAndGetDealers(partnumber);
                }
                if (partnumber != null && this.product.HasVariations && this.product.Colors.length <= 1) { //set different image
                    vueStore.state.activeImage = this.cloudinaryImageByPartnumberCode(partnumber.code);
                }
                //track GA
                window.trackEventGlobalAndLocal('Select your size', 'Click', document.title);
                //GA4
                if (partnumber != null && this.product.Partnumbers.length > 1) {
                    window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'select_size', 'ga4_model_category': this.product.GA_Category, 'ga4_model_name': this.product.Product.Name, 'ga4_click_text': partnumber.description });
                }
            },
            setPartnumberAndGetDealers(partnumber) {
                // remove selected dealer
                this.removeSelectedDealer();
                // reset dealer search settings
                this.resetDealerSearch();
                //reset notify me form
                this.isNotifyMeVisible = false;
                // commit action to store
                vueStore.commit('setPartnumber', partnumber);
                //reset required label
                this.showLabelRequiredPartnumber = false;
                // check stock code - if not 0 (soldout), only bikes and no store site then get dealers by location
                //if (partnumber != null && this.product.Product.ProductType == 1 && partnumber.stock.Code != 0 && (window.store == undefined || window.store.length == 0)) {
                //    this.getDealersByGeocode(this.clientLocation.lat, this.clientLocation.lng)
                //}
                if (partnumber != null && partnumber.stock.Code != 0 && partnumber.stock.ContainsLocalstock == true && (window.store == undefined || window.store.length == 0)) {
                    this.getDealersByGeocode(this.clientLocation.lat, this.clientLocation.lng)
                }
                if (partnumber != null && partnumber.stock.Code == 2 && partnumber.stock.ContainsLocalstock == true && partnumber.stock.IsRetailDirectToConsumer == false) {
                    this.setShowDealerSelector = true;
                } else {
                    this.setShowDealerSelector = false;
                }
                //set default shipping option
                //this.shippingOption = this.getFirstShippingOptionAvailable();
            },
            //setShippingOption(shippingoption) {
            //    this.shippingOption = shippingoption;
            //},
            resetDealerSearch() {
                this.isWillingToTakeARoadTrip = false;
                this.isDealerSearchFieldEnabled = false;
                this.isDealerListVisible = false;
                this.isLocalStockOnlyMode = true;
            },
            showAddOnOverlayImage(addon) {
                if (!this.hasProductInCart(addon.GearGlobalProductId)) {
                    addon.IsSelected = true;
                }
            },
            hideAddOnOverlayImage(addon) {
                if (!this.hasProductInCart(addon.GearGlobalProductId)) {
                    addon.IsSelected = false;
                }
            },
            getDealersByGeocode(lat, lng) {
                console.log("getDealersByGeocode");
                var that = this;
                this.exceptionMessageDealers = '';
                // define url
                var url = '/' + window.culture + '/shop/dealers2' + (window.store != undefined && window.store.length > 0 ? '?store=' + window.store : '');
                // create object
                var myDealerRequest = {
                    partnumberCode: this.partnumber.code,
                    productId: this.id,
                    productType: this.producttypeid,
                    latitude: lat != undefined ? lat : window.defaultLatitude,
                    longitude: lng != undefined ? lng : window.defaultLongitude
                }
                // call api
                axios({
                    method: "post",
                    url: url,
                    data: myDealerRequest,
                })
                    .then(function (response) {
                        //handle success
                        if (response.data) {
                            // put data in store
                            vueStore.commit('setDealers', response.data)
                            // Set the active dealers with logic based on the data
                            that.setActiveDealers()
                        }
                    })
                    .catch(function (response) {
                        //handle error
                        that.exceptionMessageDealers = response;
                        console.error(response)
                    });
            },
            getDealersByLocation() {
                this.loadingDealers = true;
                this.exceptionMessageDealers = '';
                var callback = function (that, lat, lng) {
                    if (lat != undefined) {
                        that.getDealersByGeocode(lat, lng);
                        that.isClientSearchFieldEnabled = false;
                    } else {
                        // do we need something here?
                        that.exceptionMessageDealers = 'Could not find this place'
                    }
                };
                this.setClientLocation(this.dealerSearchCity, callback, this);
            },
            isSelectedDealerInfoVisible(item) {
                return (this.selectedDealer && this.selectedDealer?.Code && item && item.stock.Code > 0 && this.inProgressAddingProductToCart == false);
            },
            hasWarehouseDealers() {
                return (this.dealers?.filter(x => x.Type == 'warehouse').length > 0);
            },
            hasLocalStockDealers() {
                return (this.dealers?.filter(x => x.Type == 'local').length > 0);
            },
            hasLocalStockDealersWithinRadius() {
                return (this.dealers?.filter(x => x.Type == 'local' && x.IsDealerWithinRadius == true).length > 0);
            },
            hasAnyDealers() {
                return (this.hasWarehouseDealers() || this.hasLocalStockDealers());
            },
            isAddToCartButtonVisible() {
                var enable = false;
                // can we show the ADD TO CART button?
                //if (this.product && this.product.Product && item && item.stock.Code > 0 && this.hasWarehouseDealers()) {
                //    // scenario 1: warehouse stock dealers AND stock > 0
                //    enable = true;
                //}
                if (this.product && this.product.Product && this.partnumber && (this.partnumber.stock.Code == 1 || this.partnumber.stock.Code == 3)) {
                    // scenario 1: warehouse or pre-order stock available
                    enable = true;
                }
                else if (this.product && this.product.Product && this.partnumber && this.partnumber.stock.Code > 0 && this.hasLocalStockDealers() && this.hasSelectedDealer) {
                    // scenario 2: local stock dealers AND selected dealer AND stock > 0
                    enable = true;
                }
                else if (this.product && this.product.Product && this.partnumber && this.partnumber.stock.IsRetailDirectToConsumer) {
                    // scenario 3: RD2C
                    enable = true;
                } else if (this.isStore && this.product.StoreSaleProduct != null) {
                    enable = false;
                } else if (this.partnumber == null) {
                    //scenario 4: no partnumber selected. Show disabled button
                    enable = true;
                } else if (this.isStore) {
                    //scenario 5: store scenarios
                    if (this.partnumber && this.partnumber.stock.Code == 2 && this.sellLocalStockStoreSites) {
                        enable = true;
                    }
                }
                return enable;
            },
            isContactButtonVisible() {
                var enable = false;
                if (this.isStore == true) {
                    if (this.isAddToCartButtonVisible() == false && this.partnumber && this.partnumber.stock.Code == 2) {
                        enable = true;
                    } else if (this.product.StoreSaleProduct != null) {
                        enable = true;
                    } else if (this.partnumber && this.partnumber.stock.Code == 0) {
                        enable = true;
                    }
                }
                return enable;
            },
            setActiveDealers(showAllDealers = false) {
                console.log("setActiveDealers() - showAllDealers : " + showAllDealers);
                if (showAllDealers || this.isLocalStockOnlyMode == false) {
                    // Set active dealers to all available dealers.
                    // Sort by distance, smallest distance first.
                    this.activeDealers = this.warehouseAndlocalstockDealersWithinRadius
                        .slice()
                        .sort(function (a, b) {
                            return a.Distance - b.Distance;
                        });
                } else {
                    if (this.hasLocalStockDealers()) {
                        // scenario: local dealers
                        this.isDealerListVisible = true;
                        //show dealer search
                        this.isDealerSearchFieldEnabled = true;
                        console.log("show all local dealers inside and outside radius");
                        // scenario: local dealers outside radius only
                        this.activeDealers = this.localstockDealers;
                    }
                    // in roadtrip mode always show list
                    if (this.isWillingToTakeARoadTrip == true) {
                        this.isDealerListVisible = true;
                    }
                }
                // loading done
                this.loadingDealers = false;
            },
            //onPickupAtAnyRetailerClick() {
            //    // this is warehouse mode
            //    this.isLocalStockOnlyMode = false
            //    // Set Active dealers with showAllDealers = true
            //    this.setActiveDealers(true)
            //    // show dealers list, searchfield and filter
            //    this.isDealerListVisible = true
            //    this.isDealerSearchFieldEnabled = true
            //},
            onRetailersNearCityClick() {
                this.showLocalStockDealers()
            },
            onRoadTripDealersClick() {
                console.log("on road trip dealers click");
                // set to road trip mode
                this.isWillingToTakeARoadTrip = true;
                // show local dealers
                this.showLocalStockDealers()
            },
            showLocalStockDealers() {
                // set mode to local
                this.isLocalStockOnlyMode = true;
                // show dealers list, search
                this.isDealerListVisible = true
                this.isDealerSearchFieldEnabled = true
                this.isAvailableInTextVisible = true
                // set Active dealers
                this.setActiveDealers()
            },
            isLocalStockFilterCheckboxVisible() {
                var hasLocalAndWarehouseStock = this.dealers.findIndex(x => x.Type == 'local') > -1 && this.dealers.findIndex(x => x.Type == 'warehouse') > -1 && this.isDealerListVisible;
                return hasLocalAndWarehouseStock;
            },
            toggleLocalStockOnlyMode() {
                this.setActiveDealers(!this.isLocalStockOnlyMode)
            },
            setClientLocation(item, callback, that, skipCountry) {
                var thisParent = this
                window.getLatLng(item + (skipCountry == true ? '' : ' ' + window.country), function (lat, lng) {
                    if (lat != null) {
                        var clientlocation = { city: item, lat: lat, lng: lng }
                        vueStore.commit('setClientLocation', clientlocation)
                        document.cookie = 'clientLocation=' + JSON.stringify(clientlocation) + '; path=/' + window.culture;
                        if (callback) {
                            callback(that, lat, lng)
                        }
                    } else if (skipCountry == true) {
                        //stop trying....
                        if (callback) {
                            callback(that, lat, lng)
                        }
                    } else {
                        //try to find without country suffix
                        thisParent.setClientLocation(item, callback, that, true)
                    }
                })
            },
            getClientLocation() {
                var clientLocation = window.readCookie('clientLocation')
                if (clientLocation != null) {
                    try {
                        vueStore.commit('setClientLocation', JSON.parse(clientLocation))
                    } catch (e) {
                        console.log(e);
                    }
                }
            },
            getBrowserLocation(callback) {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        var latlng = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                        var geocoder = new window.google.maps.Geocoder();
                        geocoder.geocode({ latLng: latlng }, function (results, status) {
                            var city = '';
                            if (status == window.google.maps.GeocoderStatus.OK) {
                                if (results[1]) {
                                    var arrAddress = results;
                                    console.log(results);
                                    for (var i = 0; i < arrAddress.length; i++) {
                                        if (arrAddress[i].types[0] == "locality") {
                                            console.log("dealercity: " + arrAddress[i].address_components[0].long_name);
                                            city = arrAddress[i].address_components[0].long_name;
                                        }
                                    }
                                    if (city.length == 0) {
                                        //try to find by administrative_area_level_4
                                        for (var j = 0; j < arrAddress.length; j++) {
                                            if (arrAddress[j].types[0] == "administrative_area_level_4") {
                                                console.log("dealercity: " + arrAddress[j].address_components[0].long_name);
                                                city = arrAddress[j].address_components[0].long_name;
                                            }
                                        }
                                    }
                                    if (city.length == 0) {
                                        //try to find by postal_town
                                        for (var k = 0; k < arrAddress.length; k++) {
                                            if (arrAddress[i].types[0] == "postal_town") {
                                                console.log("dealercity: " + arrAddress[k].address_components[0].long_name);
                                                city = arrAddress[k].address_components[0].long_name;
                                            }
                                        }
                                    }
                                } else {
                                    city = window.lblNoLocationFound;
                                }
                            } else {
                                //Raygun.send("Google Maps Geocoder exception. Status: " + status);
                                city = "Geocoder failed due to: " + status;
                            }
                            var clientlocation = { city: city, lat: position.coords.latitude, lng: position.coords.longitude }
                            vueStore.commit('setClientLocation', clientlocation)
                            document.cookie = 'clientLocation=' + JSON.stringify(clientlocation) + '; path=/' + window.culture;
                            if (callback) {
                                callback();
                            }
                        });
                    }, function () {
                        if (callback) {
                            callback();
                        }
                    }, { timeout: 5000 });//5sec
                }
            },
            toggleNotifyMeForm() {
                this.isNotifyMeVisible = !this.isNotifyMeVisible;
                //track GA
                window.trackEventGlobalAndLocal('Notify me when available', 'Click', document.title);
            },
            cloudinaryImageByPartnumberCode(partnumberCode) {
                for (var i = 0; i < this.product.Product.CloudinaryImagesToPartnumbers.length; i++) {
                    for (var j = 0; j < this.product.Product.CloudinaryImagesToPartnumbers[i].PartnumberCodes.length; j++) {
                        if (this.product.Product.CloudinaryImagesToPartnumbers[i].PartnumberCodes[j] == partnumberCode) {
                            return this.product.Product.CloudinaryImagesToPartnumbers[i];
                        }
                    }
                }
            },
            toggleEnterLocation() {
                this.enterLocationEnabled = !this.enterLocationEnabled;
            },
            trackEventBikeAdvancedSizingTool() {
                // old tracking
                window.trackEventGlobalAndLocal('Bike sizing tool', 'Click', 'Initialize tool - ' + this.product.Product.Name)
                // SK add ga4 tracking
                var clickText = this.getInterfaceText('shop_whatismysize');
                window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'what_is_my_size', 'ga4_model_category': this.product.GA_Category, 'ga4_model_name': this.product.Product.Name, 'ga4_click_text': clickText });
            },
            trackPickItUpInStore() {
                // SK add ga4 tracking
                var clickText = this.getInterfaceText('page_whypickupinstore_link_label');
                window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'why_pickup_in_store', 'ga4_model_category': this.product.GA_Category, 'ga4_model_name': this.product.Product.Name, 'ga4_click_text': clickText });
            },
            addToCart() {
                if (this.partnumber != null) {
                    this.addCartItem(this.partnumber.code, this.product.Product.Id, this.product.Product.ProductType, this.product.Product, null, function () { document.getElementById("cart-summary-container2").click(); });
                } else {
                    this.showLabelRequiredPartnumber = true;
                }
            },
            resetDefaultPartnumber() {
                this.partnumberDefault = null;
            },
            sendToContact() {
                window.location = '/' + this.culture + '/contact';
            },
            sendContactForm() {
                if (this.isSending == false) {
                    this.errorContact = '';
                    this.isSending = true;
                    this.formHasBeenSent = false;

                    if (this.contactFirstName != null && this.contactFirstName.length > 0 && this.contactLastName != null && this.contactLastName.length > 0 && this.contactEmail != null && this.contactEmail.length > 0 && this.contactQuestion != null && this.contactQuestion.length > 0) {

                        var that = this;
                        // handle recaptcha
                        this.grecaptcha.ready(function () {
                            this.grecaptcha.execute(window.GoogleRecaptchaSiteKey, { action: 'social' })
                                .then(function (token) {
                                    const url = `/${that.$root.culture}/contact/sendjson`;

                                    const formData = {
                                        FirstName: that.contactFirstName,
                                        LastName: that.contactLastName,
                                        email: that.contactEmail,
                                        phone: that.contactPhone,
                                        size: that.contactSize,
                                        question: that.contactQuestion,
                                        ProductId: that.product.Product.Id,
                                        ProductType: that.product.Product.ProductType,
                                        isGlobalCatalogue: that.product.Product.IsGlobalCatalogue,
                                        token: token
                                    };

                                    axios({
                                        method: "post",
                                        url: url,
                                        data: formData,
                                    })
                                        .then(function (res) {
                                            //handle success
                                            if (res.data === 'True') {
                                                that.formHasBeenSent = true;
                                                //setTimeout(() => {
                                                //    that.showContactModal = false;
                                                //}, 2000);
                                                that.isSending = false;
                                            } else {
                                                that.errorContact = res.data;
                                                that.isSending = false;
                                            }
                                        })
                                        .catch(function () {
                                            //handle error
                                            that.errorContact = 'An error occurred while sending the form';
                                            that.isSending = false;
                                        });
                                })
                                .catch(function (ex) {
                                    // any error -> set button style back to normal
                                    that.errorContact = 'Invalid token: ' + ex;
                                    that.isSending = false;
                                });
                        });
                    } else {
                        this.errorContact = this.getInterfaceText('makesureallrequiredfieldsareentered');
                        this.isSending = false;
                    }
                }
            }
        },
        computed: {
            partnumber() {
                return vueStore.state.partnumber
            },
            selectedDealer() {
                return vueStore.state.dealer
            },
            apiUrl() {
                return '/' + window.culture + '/shop/productselector/' + this.id + '/' + this.producttypeid + '/true'
            },
            product() {
                return vueStore.state.product
            },
            color: {
                get() {
                    return vueStore.state.color
                },
                set(value) {
                    vueStore.commit('setColor', value)
                }
            },
            supplementaryItem: {
                get() {
                    return vueStore.state.supplementaryItem
                },
                set(value) {
                    vueStore.commit('setSupplementaryItem', value)
                }
            },
            partnumbersByColor() {
                var partnumbers = [];
                //GDG 20240116: op usage uitgezet ivm alle maten die getoond werden voor https://test.giant-bicycles.com/us/maxxis-minion-dhf-2023
                if (this.hasUsage && this.hasDifferentSizes == false) {
                    partnumbers = this.product.Partnumbers;
                } else {
                    partnumbers = this.product.Partnumbers?.filter(x => x.color == this.color);
                }
                if (partnumbers.length == 0) {
                    //voor uitzonderingen als een product een usage heeft of zoals CONTACT SLR AEROLIGHT STEM alle partnumbers tonen
                    partnumbers = this.product.Partnumbers;
                }
                //set default partnumber if it's only 1 partnumber
                if (partnumbers != null && partnumbers.length == 1) {
                    this.setPartnumberAndGetDealers(partnumbers[0]);
                }
                //set default partnumber it's in querystring
                if (this.partnumber == null && this.partnumberDefault != null) {
                    var partnumber = this.product.Partnumbers?.filter(x => x.code == this.partnumberDefault)[0];
                    this.setPartnumberAndGetDealers(partnumber);
                    this.resetDefaultPartnumber();
                }
                return partnumbers;
            },
            GAclientId() {
                var ga_clientId;
                try {
                    if (window.ga.getAll()[0].get('clientId') != undefined) {
                        ga_clientId = window.ga.getAll()[0].get('clientId');
                    }
                } catch (e) {
                    //do nothing
                }
                return ga_clientId;
            },
            isSellable() {
                return this.product.Partnumbers?.filter(x => x.stock != null && x.stock.Code != 0).length > 0
            },
            sellLocalStock() {
                return this.product.SellLocalStock;
            },
            isSoldOut() {
                return this.isSellable == false && this.product.Partnumbers?.filter(x => x.notifyMe == true).length == 0
            },
            isNotifyMe() {
                return this.isSellable == false && this.product.Partnumbers?.filter(x => x.notifyMe == true).length > 0
            },
            hasUsage() {
                return this.product.Partnumbers?.filter(x => x.hasUsage == true).length > 0
            },
            hasSizes() {
                return this.product.Partnumbers?.filter(x => x.size != null && x.size.length > 0).length > 0
            },
            hasDifferentSizes() {
                var _size = '';
                if (this.product.Partnumbers?.filter(x => x.size.length > 0).length > 0) {
                    for (var i = 0; i < this.product.Partnumbers.length; i++) {
                        if (this.product.Partnumbers[i].size != '' && this.product.Partnumbers[i].size != _size) {
                            if (_size.length > 0) {
                                return true;
                            } else {
                                _size = this.product.Partnumbers[i].size;
                            }
                        }
                    }
                }
                return false;
            },
            dealers() {
                return vueStore.state.dealers
            },
            warehouseDealers() {
                if (this.dealers && this.dealers.length) {
                    return this.dealers.filter(x => x.Type == 'warehouse');
                } else {
                    return [];
                }
            },
            localstockDealers() {
                if (this.dealers && this.dealers.length) {
                    return this.dealers.filter(x => x.Type == 'local');
                } else {
                    return [];
                }
            },
            localstockDealersWithinRadius() {
                if (this.dealers && this.dealers.length) {
                    return this.dealers.filter(x => x.Type == 'local' && x.IsDealerWithinRadius);
                } else {
                    return [];
                }
            },
            warehouseAndlocalstockDealersWithinRadius() {
                if (this.dealers && this.dealers.length) {
                    return this.dealers.filter(x => x.IsDealerWithinRadius);
                } else {
                    return [];
                }
            },
            warehouseAndlocalstockDealersWithinHomeDeliveryRadius() {
                if (this.dealers && this.dealers.length) {
                    return this.dealers.filter(x => x.IsDealerWithinHomeDeliveryRadius);
                } else {
                    return [];
                }
            },
            hasSelectedDealer() {
                var dealerSelected = false;
                if (this.selectedDealer && this.selectedDealer?.Code) {
                    dealerSelected = true;
                }
                console.log("dealerSelected: " + dealerSelected);
                return dealerSelected;
            },
            clientLocation() {
                return vueStore.state.clientLocation
            },
            addOns() {
                return this.product.Product?.AddOns;
            },
            bundles() {
                return this.product.BundleItems;
            },
            showDealerSelector() {
                return this.partnumber.stock.IsRetailDirectToConsumer == false || this.setShowDealerSelector == true;
            },
            inProgressAddingProductToCart() {
                return vueStore.state.addingProductToCart
            },
            showWhereToGet() {
                return this.partnumber != null &&
                    this.pickupAvailable == true &&
                    this.countryId != 14 &&
                    (this.partnumber.stock.Code == 1 &&
                        this.product.Product.ProductType == 1 &&
                        this.partnumber.stock.IsRetailDirectToConsumer == false ||
                        this.partnumber.stock.Code == 3)
            },
            stockDescription() {
                return this.partnumber != null && this.partnumber.stock != null ? this.partnumber.stock.Description : '';
            },
            isRetailDirectToConsumer() {
                return this.partnumber != null && this.partnumber.stock != null && (this.partnumber.stock.IsRetailDirectToConsumer || this.product.DirectshipmentAvailableGear == true && this.partnumber.stock.Code == 1);
            },
            productId() {
                return vueStore.state.productId;
            }
        },
        beforeMount() {
            this.fetchApi()
            this.getClientLocation();
            if (this.clientLocation != null && this.clientLocation.city != null) {
                this.dealerSearchCity = this.clientLocation.city
            } else {
                var that = this;
                this.getBrowserLocation(function () {
                    if (that.clientLocation != null && that.clientLocation.city != null) {
                        that.dealerSearchCity = that.clientLocation.city
                    } else {
                        that.dealerSearchCity = window.defaultCityEnglish;
                    }
                });
            }
        },
        watch: {
            //productId(newValue, oldValue) {
            //    //productId selected in product configurator
            //    console.log(`ProductId changed from "${oldValue}" to "${newValue}"`);
            //    this.id = newValue;
            //    //this.producttypeid = 1;
            //    //get product from Ajax call
            //    this.fetchApi()
            //}
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);
            this.pickupAvailable = document.getElementById('vue-product-selector-v2').dataset.pickupavailable == 'true';
            this.showShippingCostsAtProductSelector = document.getElementById('vue-product-selector-v2').dataset.showshippingcostsatproductselector == 'true';
            this.id = document.getElementById('vue-product-selector-v2').dataset.productid;
            this.producttypeid = document.getElementById('vue-product-selector-v2').dataset.producttypeid;
            this.partnumberDefault = window.getParameterByName('partnumber'); //document.getElementById('vue-product-selector-v2').dataset.partnumberdefault;
            this.showBikeAdvancedSizingTool = document.getElementById('vue-product-selector-v2').dataset.showbikeadvancedsizingtool == 'true';
            this.displayInstockLabelAsInfoIconPopout = document.getElementById('vue-product-selector-v2').dataset.displayinstocklabelasinfoiconpopout == 'true';
            this.viewmode = document.getElementById('vue-parameters').dataset.viewmode;
            this.sellLocalStockStoreSites = document.getElementById('vue-product-selector-v2').dataset.selllocalstockstoresites == 'true';
        },
        mounted() {
            window.loadExternalScript('https://web-sdk.eyefitu.com/v1/sdk/init.js', function () {
                if (!window.eyefitu) {
                    window.eyefituCalls = [];
                    window.eyefitu = function () { window.eyefituCalls.push(arguments) };
                }
                window.eyefitu('store', 'www.giant.com');
                window.eyefitu('init');
            });
        }
    }
</script>
